import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"fill-height"},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"12","sm":"8","md":"6"}},[(!_vm.$vuetify.breakpoint.xs)?_c(VCard,{staticClass:"pt-10 pb-10 pl-8 pr-8",attrs:{"elevation":"4","light":"","tag":"section"}},[_c(VCardText,[_c('LoginForm')],1)],1):_c('LoginForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }